'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReservationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

var _utils2 = require('../core/utils.js');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// const DUMMY = require('!json-loader!../../doc/dummyData/winresExtraServicesNew.json');
var DUMMY_SERVICES = require('!json-loader!../../doc/dummyData/winresServices.json');

var ReservationService = exports.ReservationService = function () {
    function ReservationService(winresCloudService, cancelService, $timeout) {
        _classCallCheck(this, ReservationService);

        this.winresCloudService = winresCloudService;
        this.cancelService = cancelService;
        this.$timeout = $timeout;
        this.extraServicePromises = {};
    }

    // K&K 2.0 / Reservation components
    // Gets a list of available payment methods. Session may be NULL, but if it
    // is, payment fee cannot be calculated.


    _createClass(ReservationService, [{
        key: 'getPaymentMethods',
        value: function getPaymentMethods(bookingSession) {
            if ((0, _utils.hasClearlyInvalidPassengerAssignments)(bookingSession)) {
                // console.log('[RS getPaymentMethods] Skipping request due to missing passenger assignments.');
                // Using CancelService here because the callers expect a cancelable promise.
                return this.cancelService.resolve(undefined);
            }

            var session = (0, _utils.toSimpleSession)(bookingSession);
            var language = this.winresCloudService.getLanguage();

            // https://www.ahtarizoo.fi/index.php/fi/ostoskori'

            return this.winresCloudService.makeAuthenticatedRequest('GetPaymentmethods', {
                Session: session,
                Language: language
            });
        }
    }, {
        key: 'getSettingsForCongressRooms',
        value: function getSettingsForCongressRooms() {
            var lang = this.winresCloudService.getLanguage();
            return this.winresCloudService.makeAuthenticatedRequest('GetSettingsForCongressRooms', {
                Language: lang
            });
        }
    }, {
        key: 'getPaymentMethodsAndParameters',
        value: function getPaymentMethodsAndParameters(bookingSession, amountToPay) {
            if ((0, _utils.hasClearlyInvalidPassengerAssignments)(bookingSession)) {
                // console.log('[RS getPaymentMethods] Skipping request due to missing passenger assignments.');
                // Using CancelService here because the callers expect a cancelable promise.
                return this.cancelService.resolve(undefined);
            }

            var session = (0, _utils.toSimpleSession)(bookingSession);
            var language = this.winresCloudService.getLanguage();

            // https://www.ahtarizoo.fi/index.php/fi/ostoskori'

            return this.winresCloudService.makeAuthenticatedRequest('GetPaymentMethodsAndParameters', {
                Session: session,
                Language: language,
                AmountToPay: amountToPay
            });
        }

        // K&K 2.0 / Reservation components
        // gets all the bills/different amounts to pay.

    }, {
        key: 'GetPaymentOptions',
        value: function GetPaymentOptions(bookingSession) {
            return this.winresCloudService.makeAuthenticatedRequest('GetPaymentOptions', {
                Session: (0, _utils.toSimpleSession)(bookingSession)
            });
        }
    }, {
        key: 'getPaymentOptionsWithResponse',
        value: function getPaymentOptionsWithResponse(bookingSession) {
            var language = this.winresCloudService.getLanguage();

            return this.winresCloudService.makeAuthenticatedRequestWithResponse('GetPaymentOptions', {
                Session: (0, _utils.toSimpleSession)(bookingSession),
                Language: language
            });
        }

        // K&K 2.0 / Reservation components
        // (internalName = internal name of the payment method, e.g. NTS for Nets)

    }, {
        key: 'prebookAndGetPaymentMethod',
        value: function prebookAndGetPaymentMethod(bookingSession, internalName, okUrl, cancelUrl, rejectUrl, amountToPay, language, onError) {
            return this.winresCloudService.makeAuthenticatedRequest('PrebookAndGetPaymentMethod', {
                Session: (0, _utils.toSimpleSession)(bookingSession),
                InternalName: internalName,
                OkUrl: okUrl,
                CancelUrl: cancelUrl,
                RejectUrl: rejectUrl,
                AmountToPay: amountToPay,
                Language: language,
                UseTestPayment: (0, _utils2.getParameter)('useTestPayment')
            }, undefined, undefined, undefined, onError);
        }

        // K&K 2.0 / Reservation components
        // ReturnUrl - URL of the session. The backend authenticates using this one,
        // not the session.

    }, {
        key: 'confirmBookingByReturnUrl',
        value: function confirmBookingByReturnUrl(returnUrl) {
            // Note: not an authenticated request, since the URL contains the
            // sessionId (prebook number) which is used to authenticate the request.
            // Thus, confirming works even if the session has disappeared.
            return this.winresCloudService.makeRequest('ConfirmBookingByReturnUrl', {
                ReturnUrl: returnUrl
            });
        }

        // K&K 2.0 / Reservation components

    }, {
        key: 'confirmBookingByInvoice',
        value: function confirmBookingByInvoice(session, language) {
            return this.winresCloudService.makeAuthenticatedRequest('ConfirmBookingByInvoice', {
                Session: (0, _utils.toSimpleSession)(session),
                Language: language
            });
        }

        // Calculates product prices for product + passengers of the product combos.
        // (language needed for price label fetching)

    }, {
        key: 'calculateProductLinePrices',
        value: function calculateProductLinePrices(session, productLines, language) {
            if ((0, _utils.hasClearlyInvalidPassengerAssignments)(session)) {
                // console.log('[RS calculateProductLinePrices] Skipping request due to missing passenger assignments:', productLines);
                // Using CancelService here because the callers expect a cancelable promise.
                return this.cancelService.resolve(undefined);
            }

            return this.winresCloudService.makeAuthenticatedRequest('CalculateProductLinePrices', {
                ProductLines: (0, _utils.toSimpleProductLines)(productLines),
                Passengers: (0, _utils.toSimplePassengers)(session.Passengers),
                Language: language
            });
        }
    }, {
        key: 'calculateProductLinePricesSimple',
        value: function calculateProductLinePricesSimple(productLines, passengers, language) {
            return this.winresCloudService.makeAuthenticatedRequest('CalculateProductLinePrices', {
                ProductLines: productLines,
                Passengers: (0, _utils.toSimplePassengers)(passengers),
                Language: language
            });
        }

        // Calculates a single product line price for product + passengers of the
        // product combos. (language needed for price label fetching)

    }, {
        key: 'calculateProductLinePrice',
        value: function calculateProductLinePrice(session, productLine, language) {
            return this.calculateProductLinePrices(session, [productLine], language).then(function (results) {
                if (results === undefined) {
                    // It was canceled
                    return undefined;
                }

                return results && results.length > 0 ? results[0] : null;
            });
        }

        // Calculates the hidden price of the session. This includes hidden products (piilotetut linkitykset)
        // and office fee (varausmaksu/XXTST) but excludes payment method fee (luottokorttilisä)

    }, {
        key: 'calculateHiddenPrice',
        value: function calculateHiddenPrice(session, language) {
            // The old call sends the entire session as a parameter, even though
            // only a few values are needed. The 2nd version only takes the necessary
            // parameters.
            var simpleInput = {
                PriceGroup: session.PriceGroup,
                Passengers: session.Passengers,
                Departures: _.map(session.Departures, function (dep) {
                    return {
                        DestinationCode: dep.DestinationCode,
                        BeginDate: dep.DepartureDate,
                        EndDate: dep.ArrivalDate2
                    };
                })
            };

            return this.winresCloudService.makeAuthenticatedRequest('CalculateHiddenPrice2', {
                Language: language,
                Input: simpleInput
            });
        }
    }, {
        key: 'getExtraServices',
        value: function getExtraServices(language, startDate, endDate, destCode, numAdults, numChildren, numInfants) {
            // Used to get cached result.
            var cacheKey = destCode + '|' + startDate + '|' + endDate + '|' + numAdults + '|' + numChildren + '|' + numInfants;

            return this.winresCloudService.makeAuthenticatedRequest('GetExtraServices', {
                Params: {
                    Language: language,
                    DestCode: destCode,
                    StartDate: startDate,
                    EndDate: endDate,
                    Num: {
                        Adult: numAdults,
                        Child: numChildren,
                        Infant: numInfants
                    }
                }
            }, undefined, undefined, cacheKey);
        }
    }, {
        key: 'getServices',
        value: function getServices(language, beginDate, endDate, destCode, prodCode, passengers) {
            // const timeout = this.$timeout(20);
            // return timeout.then(
            //     () => {
            //         return DUMMY_SERVICES;
            //     }
            // );

            return this.winresCloudService.makeAuthenticatedRequest('GetServices', {
                Params: {
                    Language: language,
                    BeginDate: beginDate,
                    EndDate: endDate,
                    DestCode: destCode,
                    ProdCode: prodCode,
                    Passengers: passengers
                }
            });
        }
    }]);

    return ReservationService;
}();

ReservationService.$inject = ['winresCloudService', 'cancelService', '$timeout'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/reservationService.js
// module id = 562
// module chunks = 2